import { useLocation, useSearchParams } from 'react-router-dom'
import { HealthSearchParam } from './types'

/**
 * The page's settings from the URL, a setter that replaces the history entry rather than adding one, and the
 * current URL for links to pass as their back target.
 */
export const useHealthSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const location = useLocation()

  const setParam = (key: HealthSearchParam, value?: string) => {
    setSearchParams(
      (previous) => {
        const next = new URLSearchParams(previous)
        if (value) {
          next.set(key, value)
        } else {
          next.delete(key)
        }
        return next
      },
      { replace: true },
    )
  }

  return { searchParams, setParam, currentHref: `${location.pathname}${location.search}` }
}
